// import React, { useState, useEffect } from 'react';
// import { Row, Card, Divider, message, Tag, Typography, Col } from 'antd';
// import _commonService from '../../../modules/commonService';
// import { COMMON_ERROR_MSG } from '../../../constants/constants';
// import _consumerService from '../../../modules/consumerService';
// import { QuestionCircleOutlined, EditOutlined } from '@ant-design/icons';
// import { useHistory, useParams } from "react-router-dom";
// import { routes } from '../../../routes/Routes';
// // import CommentSection from '../Administrator/CommentSection';
// import ReviewCommentByApplicationIdAndSection from '../Administrator/ReviewCommentByApplicationIdAndSection';
// const { Title, Text, Paragraph } = Typography;


// const BalanceSheetQuestionnaireConsumerDashboard = ({ activeKey, isUsedInBanker, applicationstatusid }) => {
//     const LoanOfficerId = localStorage.getItem("LoanOfficerId");
//     const ApplicationObjID = localStorage.getItem("ApplicationObjId");
//     const BankerId = localStorage.getItem("BankerId");
//     const [questions, setQuestions] = useState([]);
//     const [answers, setAnswers] = useState([]);
//     const [LoanOfficerID] = useState(LoanOfficerId);
//     const [BankerID] = useState(BankerId);
//     const history = useHistory();
//     const params = useParams();


//     const applicationId = localStorage.getItem("ApplicationObjId");
//     const ApplicationObjId = params.Id;

//     useEffect(() => {

//         fetchQuestions();
//         fetchAnswersByApplicationId();
//     }, []);

//     const fetchQuestions = async () => {
//         try {
//             const res = await _consumerService.getAllQuestions();
//             if (res.data?.IsSuccess && Array.isArray(res.data.Obj)) {
//                 setQuestions(res.data.Obj);
//             } else {
//                 message.error(res.data.Message || COMMON_ERROR_MSG);
//             }
//         } catch (error) {
//             console.error(error);
//         } finally {
//             //   setLoading(false);
//         }
//     };

//     const fetchAnswersByApplicationId = async () => {
//         try {
//             const res = await _consumerService.getQuestionsByApplicationID(isUsedInBanker ? ApplicationObjId : applicationId);
//             if (Array.isArray(res.data) && res.data.length > 0) {
//                 setAnswers(res.data);
//             } else {
//                 message.error(res.data.Message || COMMON_ERROR_MSG);
//             }
//         } catch (error) {
//             console.error(error);
//         } finally {
//             // setLoading(false);
//         }
//     };


//     // Group questions by their QuestionType
//     const groupedQuestions = questions.reduce((acc, question) => {
//         if (!acc[question.QuestionType]) {
//             acc[question.QuestionType] = [];
//         }
//         acc[question.QuestionType].push(question);
//         return acc;
//     }, {});

//     const balanceSheetQuestionnaireEditClick = () => {
//         // history.push({
//         //     pathname: routes.questionnaire.path,
//         //     state: { applicationObjId: localStorage.getItem("ApplicationObjId"), isFromDashboard: true, activeKey: activeKey },
//         // });
//         history.push({pathname: routes.questionnaireForConsumer.path, state: { isFromDashboard: false }});

//     }

//     return (
//         <Card
//             title={
//                 <Row justify="space-between" align="middle" className="balance-heading">
//                     <Text strong>
//                         <span role="img" aria-label="user" style={{ marginRight: 8 }}><QuestionCircleOutlined /> </span>
//                         Balance Sheet – Questionnaire
//                     </Text>
//                     {!isUsedInBanker &&
//                         <EditOutlined onClick={balanceSheetQuestionnaireEditClick} style={{ color: "#595959", cursor: "pointer" }} />
//                     }
//                 </Row>
//             }

//             className="mb10 mr5 cardViewMain"

//         >
//             <div className="alignment-padding">

//                 {Object.entries(groupedQuestions).map(([section, questionsInSection]) => (

//                     <div key={section}>
//                         <Typography.Title level={5}>{section == "Asset" ? "Assets:" : "Contingent Liabilities:"}</Typography.Title>

//                         {questionsInSection.map((question) => {
//                             const answerRecord = answers.find(
//                                 (ans) => ans.QuestionId === question.Id
//                             );

//                             // Default values if answer not found
//                             const answerExists = !!answerRecord;
//                             const isYes = answerExists ? answerRecord.Answer : false;
//                             const amount = answerRecord?.Amount;
//                             const description = answerRecord?.Description;

//                             return (
//                                 <div key={question.Id}>
//                                     <Row gutter={16} justify="space-between">
//                                         <Col span={isUsedInBanker ? 22 : 16}>
//                                             <Paragraph style={{ marginBottom: 10 }}>
//                                                 {question.QuestionText}
//                                             </Paragraph>
//                                         </Col>

//                                         <Col span={isUsedInBanker ? 2 : 3}>
//                                             <Tag
//                                                 color={isYes ? 'green' : 'red'}
//                                             >
//                                                 {answers?.length == 0 ? "N/A" : isYes ? 'Yes' : 'No'}
//                                             </Tag>
//                                         </Col>
//                                     </Row>

//                                     {isYes && question.Is_Descriptive && (
//                                         <>
//                                             <Paragraph style={{ marginBottom: 10 }}>
//                                                 <strong>Amount:</strong> $ {_commonService.formatNumberWithCommas(amount) || 'N/A'}
//                                             </Paragraph>
//                                             <Paragraph style={{ marginBottom: 10 }}>
//                                                 <strong>Comments:</strong> {description || 'N/A'}
//                                             </Paragraph>
//                                         </>
//                                     )}

//                                     <Divider style={{ margin: "10px 0" }} />
//                                 </div>
//                             );
//                         })}
//                     </div>

//                 ))}

//                 {/* {
//                     (LoanOfficerID || BankerID) && <CommentSection CommentSectionName="questionair" applicationstatusid={applicationstatusid} />
//                 }
//                 {
//                     (ApplicationObjID) && <ReviewCommentByApplicationIdAndSection CommentSectionName="questionair" />
//                 } */}



//             </div>
//         </Card>
//     );
// };

// export default BalanceSheetQuestionnaireConsumerDashboard;

import React, { useState, useEffect } from 'react';
import { Row, Card, Divider, message, Typography, Col } from 'antd';
import _commonService from '../../../modules/commonService';
import { COMMON_ERROR_MSG } from '../../../constants/constants';
import _consumerService from '../../../modules/consumerService';
import { QuestionCircleOutlined, EditOutlined } from '@ant-design/icons';
import { useHistory, useParams } from "react-router-dom";
import { routes } from '../../../routes/Routes';
const { Title, Text, Paragraph } = Typography;

const BalanceSheetQuestionnaireConsumerDashboard = ({ activeKey, isUsedInBanker, applicationstatusid }) => {
    const LoanOfficerId = localStorage.getItem("LoanOfficerId");
    const ApplicationObjID = localStorage.getItem("ApplicationObjId");
    const BankerId = localStorage.getItem("BankerId");
    const [questions, setQuestions] = useState([]);
    const [answers, setAnswers] = useState([]);
    const [LoanOfficerID] = useState(LoanOfficerId);
    const [BankerID] = useState(BankerId);
    const history = useHistory();
    const params = useParams();

    const applicationId = localStorage.getItem("ApplicationObjId");
    const ApplicationObjId = params.Id;

    useEffect(() => {
        fetchQuestions();
        fetchAnswersByApplicationId();
    }, []);

    const fetchQuestions = async () => {
        try {
            const res = await _consumerService.getAllQuestions();
            if (res.data?.IsSuccess && Array.isArray(res.data.Obj)) {
                setQuestions(res.data.Obj);
            } else {
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const fetchAnswersByApplicationId = async () => {
        try {
            const res = await _consumerService.getQuestionsByApplicationID(isUsedInBanker ? ApplicationObjId : applicationId);
            if (Array.isArray(res.data) && res.data.length > 0) {
                setAnswers(res.data);
            } else {
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (error) {
            console.error(error);
        }
    };

    // Group questions by their QuestionType
    const groupedQuestions = questions.reduce((acc, question) => {
        if (!acc[question.QuestionType]) {
            acc[question.QuestionType] = [];
        }
        acc[question.QuestionType].push(question);
        return acc;
    }, {});

    const balanceSheetQuestionnaireEditClick = () => {
        history.push({ pathname: routes.questionnaireForConsumer.path, state: { isFromDashboard: false } });
    }

    return (
        <Card
            title={
                <Row justify="space-between" align="middle">
                    <Title className="initial-typography" level={4}>
                        <QuestionCircleOutlined />
                        <span style={{ marginLeft: 8 }}>Balance Sheet – Questionnaire</span>
                    </Title>
                    {!isUsedInBanker &&
                        <EditOutlined onClick={balanceSheetQuestionnaireEditClick} style={{ cursor: "pointer" }} />
                    }
                </Row>
            }
            className="mb10 mr5 FinancialStatementContainer"
        >
            <div style={{padding:"24px"}}>
                <Text type="secondary" className="section-subtitle">
                    Standard institutional questions for risk and compliance purposes.
                </Text>

                <Divider style={{ margin: '8px 0' }} />

                <Row className="header-row" style={{ marginBottom: 4 }}>
                    <Col span={18}>
                        <Text strong>Question</Text>
                    </Col>
                    <Col span={6} style={{ textAlign: "right" }}>
                        <Text strong>Response</Text>
                    </Col>
                </Row>

                {Object.entries(groupedQuestions).map(([section, questionsInSection]) => (
                    <div key={section} className="question-section">
                        {/* Section Title */}
                        {/* <Row className="section-row" style={{ marginBottom: 6 }}>
                        <Col span={24}>
                            <Text strong>
                                {section === "Asset" ? "Assets" : "Contingent Liabilities"}
                            </Text>
                        </Col>
                    </Row> */}



                        {questionsInSection.map((question) => {
                            const answerRecord = answers.find(ans => ans.QuestionId === question.Id);
                            const isYes = answerRecord?.Answer;
                            const amount = answerRecord?.Amount;
                            const description = answerRecord?.Description;

                            const responseText = answers?.length === 0 || isYes === undefined || isYes === null
                                ? "N/A"
                                : isYes
                                    ? "Yes"
                                    : "No";

                            return (
                                <div key={question.Id} style={{ marginBottom: 4 }}>
                                    <Row className="question-row" justify="space-between" style={{ marginBottom: 2 }}>
                                        <Col span={18}>
                                            <Text>
                                                <span className="question-text">
                                                    {question.QuestionText}
                                                </span>
                                            </Text>
                                        </Col>

                                        <Col span={6} style={{ textAlign: "right" }}>
                                            <Text type="secondary">{responseText}</Text>
                                        </Col>
                                    </Row>

                                    {/* Show Amount and Comments if Yes and Descriptive */}
                                    {isYes && question.Is_Descriptive && (
                                        <>
                                            <Paragraph style={{ margin: '2px 0' }}>
                                                <strong>Amount:</strong> $ {_commonService.formatNumberWithCommas(amount) || 'N/A'}
                                            </Paragraph>
                                            <Paragraph style={{ margin: '2px 0' }}>
                                                <strong>Comments:</strong> {description || 'N/A'}
                                            </Paragraph>
                                        </>
                                    )}

                                    <Divider style={{ margin: '4px 0' }} />
                                </div>
                            );
                        })}
                    </div>
                ))}
            </div>
        </Card>
    );
};

export default BalanceSheetQuestionnaireConsumerDashboard;
